import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { Modal } from '../../../../components/Modal/Modal'

import { addToast } from '../../../../store/toast/toastSlice'
import { OAuth2App, ShortOAuth2App, useSetOAuth2AppPermissionsMutation } from '../../../../store/auth/auth'

interface DisableOAuth2AppModalProps {
  oAuth2App: OAuth2App | ShortOAuth2App
  show: boolean
  onHide: () => void
}

export const DisableOAuth2AppModal: React.FC<DisableOAuth2AppModalProps> = ({ oAuth2App, show, onHide }) => {
  const { name, id: appId } = oAuth2App

  const accountId = useAppSelector(selectAccountId)

  const [triggerUpdateOAuth2App, { isLoading: isUpdating }] = useSetOAuth2AppPermissionsMutation()

  const dispatch = useAppDispatch()

  const handleDisableApp = async () => {
    try {
      const response = await triggerUpdateOAuth2App({
        accountId,
        appId,
        body: {
          account: false,
        },
      })
      if (response.error) {
        dispatch(
          addToast({
            variant: 'error',
            title: 'Error',
            messages: ['Failed to disable app. Please try again.'],
          }),
        )
        return
      }
      dispatch(
        addToast({
          variant: 'success',
          title: 'Success',
          messages: ['Successfully updated.'],
        }),
      )
    } catch (e) {
      console.error(e)
      dispatch(
        addToast({
          variant: 'error',
          title: 'Error',
          messages: ['Failed to disable app. Please try again.'],
        }),
      )
    } finally {
      onHide()
    }
  }

  const body = (
    <Container>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>Users will immediately lose access to this connector. Any active sessions may be interrupted.</div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<h4 className='p-2'>Disable {name} for all users?</h4>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDisableApp}
      footerPrimaryActionLoading={isUpdating}
      footerPrimaryActionTitle='Disable'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
